<template>
    <div class="single__wrapper-inner">

        <div class="fixed-product-box">
            <template v-if="attributes.length || Object.keys(units).length">
                <variation-select type="mobile"
                                  :attribute-size-id="napoConfig.itemLists.attributeSizeId"
                                  :attribute-color-id="napoConfig.itemLists.attributeColorId">
                </variation-select>
            </template>
            <add-to-basket
                    :variation-id="currentVariation.variation.id"
                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                    :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                    :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                    :use-large-scale="false"
                    :show-quantity="true"
                    :item-url="currentVariation | itemURL"
                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                    :has-price="currentVariation | hasItemDefaultPrice"
                    type="mobile">
            </add-to-basket>
        </div>

        <div class="single__head">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-xl-8 single__left">
                        <div class="single__btn-group">

                            <div class="position-relative">
                                <button class="single__share-btn" v-toggle-social-share>
                                    <span>
                                        {{ $translate("ODNaPo::NaPo.singleShare") }}
                                    </span>
                                </button>
                                <div class="single__share-container single__share-container--hidden">
                                    <slot name="social-share"></slot>
                                </div>
                            </div>
                            <add-to-wish-list :variation-id="currentVariation && currentVariation.variation.id"></add-to-wish-list>
                        </div>

                        <slot name="image-carousel"></slot>

                    </div>

                    <div class="col-md-7 col-lg-5 col-xl-4 single__right">
                        <div class="details">
                            <div class="details__name-wrap">

                                <div v-if="currentVariation.filter.hasManufacturer"
                                     class="details__producer">
                                    <template v-if="manufacturerLink">
                                        <a :title="currentVariation | itemName"
                                           :href="manufacturerLink">
                                            {{ currentVariation.item.manufacturer.externalName }}
                                        </a>
                                    </template>
                                    <template v-else>
                                        {{ currentVariation.item.manufacturer.externalName }}
                                    </template>
                                </div>

                                <h1 class="details__name">
                                    {{ currentVariation | itemName }}
                                </h1>

                                <slot name="before-price"></slot>


                                <template v-if="isLoggedIn && (b2bClass == 4 || b2bClass == 5)">
                                    <div class="single-price">

                                        <div class="single-price__price"
                                             :class="{'single-price__price--sale': currentVariation.prices.rrp && currentVariation.prices.rrp.price.value > 0 && currentVariation.prices.rrp.price.value > currentVariation.prices.default.price.value}"
                                             ref="variationTotalPrice"
                                             :content="currentVariation.prices.default.price.value">
                                            {{ variationTotalPrice | currency(currentVariation.prices.default.currency) }}
                                        </div>
                                        <div class="single-price__crossprice"
                                             v-if="currentVariation.prices.rrp && currentVariation.prices.rrp.price.value > 0 && currentVariation.prices.rrp.price.value > currentVariation.prices.default.price.value">
                                          {{ currentVariation.prices.rrp.price.formatted }}
                                        </div>

                                      <div v-if="uvp != null" class="single-price__uvp-price">
                                        {{ $translate("ODNaPoB2B::Template.uvp") }} = {{ uvp }} {{ currentVariation.prices.default.currency }}
                                      </div>

                                        <div class="single-price__vat">
                                            <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}&nbsp;
                                            <a v-if="ceresConfig.global.shippingCostsCategoryId !== ''"
                                               href="#"
                                               data-toggle="modal"
                                               data-target="#id--shipping-costs-modal"
                                               :title="$translate('ODNaPo::NaPo.singleShipping')">
                                                {{ $translate("ODNaPo::NaPo.singleShipping") }}
                                            </a>
                                            <template v-else>
                                                {{ $translate("ODNaPo::NaPo.singleShipping") }}
                                            </template>
                                        </div>

                                        <div>
                                            <slot name="additional-content-after-vat"></slot>
                                        </div>
                                    </div>

                                    <div class="single__item-number">
                                        {{ $translate("ODNaPo::NaPo.singleItemNumber") }}&nbsp;{{ currentVariation.variation.number }}
                                    </div>
                                </template>

                                <graduated-prices template="#vue-graduated-prices"></graduated-prices>

<!--                                div für ts-widget da sonst preis nicht angezeigt wird  -->
                                <div>
                                    <slot name="after-price"></slot>
                                </div>
                                <slot name="before-add-to-basket"></slot>

                                <div class="single__variant-select">
                                    <template v-if="attributes.length || Object.keys(units).length">
                                        <variation-select type="desktop"
                                                          :attribute-size-id="napoConfig.itemLists.attributeSizeId"
                                                          :attribute-color-id="napoConfig.itemLists.attributeColorId">
                                        </variation-select>
                                    </template>
                                </div>

                                <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                    <order-property-list></order-property-list>
                                </div>

                                <template v-if="isLoggedIn && (b2bClass == 4 || b2bClass == 5)">
                                    <div :data-article-id="currentVariation.item.id">
                                        <add-to-basket
                                            :variation-id="currentVariation.variation.id"
                                            :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                            :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                            :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                            :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                            :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                            :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                            :use-large-scale="false"
                                            :show-quantity="true"
                                            :item-url="currentVariation | itemURL"
                                            :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                            :has-price="currentVariation | hasItemDefaultPrice"
                                            type="desktop">
                                        </add-to-basket>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="single__b2b-hint" v-if="b2bClass != 4 && b2bClass != 5">
                                        {{ $translate("ODNaPo::NaPo.b2bHint") }}

                                        <a href="#" class="single__b2b-hint-link">{{ $translate("ODNaPo::NaPo.b2bHintLink") }}</a>
                                    </div>
                                    <button class="w-100">
                                        <a data-toggle="modal"
                                           data-target="#id--login-modal"
                                           href="javascript:void(0)"
                                           class="btn__add-to-basket"
                                           @click="createLoginModal()">
                                            <span>
                                                {{ $translate("Ceres::Template.login") }}
                                            </span>
                                        </a>
                                    </button>
                                </template>


                                <slot name="after-add-to-basket"></slot>

                                <span data-toggle="modal"
                                      data-target="#id--single-size-modal"
                                      class="details__size-cta details__size-cta--mobile">
                                    <span>
                                        {{ $translate("ODNaPo::NaPo.sizeTable") }}
                                    </span>
                                </span>

                                <item-availability></item-availability>

                                <div class="single__description d-lg-none">
                                    <div class="single__description-col">
                                        <button class="single__description-headline collapsed"
                                                type="button"
                                                id="id--single-collapse-heading--1"
                                                data-toggle="collapse"
                                                data-target="#id--single-collapse--1"
                                                aria-expanded="false"
                                                aria-controls="id--single-collapse--1">
                                            {{ $translate("ODNaPo::NaPo.singleDescription") }}
                                        </button>
                                        <div id="id--single-collapse--1"
                                             class="collapse"
                                             aria-labelledby="id--single-collapse-heading--1">
                                            <div class="single__description-text"
                                                 v-html="currentVariation.texts.description">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="single__description-col">
                                        <button class="single__description-headline collapsed"
                                                type="button"
                                                id="id--single-collapse-heading--2"
                                                data-toggle="collapse"
                                                data-target="#id--single-collapse--2"
                                                aria-expanded="false"
                                                aria-controls="id--single-collapse--2">
                                            {{ $translate("ODNaPo::NaPo.singleShippingCosts") }}
                                        </button>
                                        <div id="id--single-collapse--2"
                                             class="collapse"
                                             aria-labelledby="id--single-collapse-heading--2">
                                            <div class="single__description-text"
                                                 v-html="$translate('ODNaPo::NaPo.singleShippingContent')">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="single__description-col">
                                        <button class="single__description-headline collapsed"
                                                type="button"
                                                id="id--single-collapse-heading--3"
                                                data-toggle="collapse"
                                                data-target="#id--single-collapse--3"
                                                aria-expanded="false"
                                                aria-controls="id--single-collapse--3">
                                            {{ $translate("ODNaPo::NaPo.singleShippingReturn") }}
                                        </button>
                                        <div id="id--single-collapse--3"
                                             class="collapse"
                                             aria-labelledby="id--single-collapse-heading--3">
                                            <div class="single__description-text"
                                                 v-html="$translate('ODNaPo::NaPo.singleShippingReturnContent')">
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-5 col-lg-12 details__usp-col">
                        <ul class="details__usp">
                            <li class="d-lg-none">
                                <p class="h4 mb-3">
                                    {{ $translate("ODNaPo::NaPo.singleAdvantages") }}
                                </p>
                            </li>
                            <li class="details__usp-item details__usp-item--2">
                                {{ $translate("ODNaPo::NaPo.singleAdvantage2") }}
                            </li>
                            <li class="details__usp-item details__usp-item--3">
                                {{ $translate("ODNaPo::NaPo.singleAdvantage3") }}
                            </li>
                            <li class="details__usp-item details__usp-item--4">
                                {{ $translate("ODNaPo::NaPo.singleAdvantage4") }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="single__description container d-none d-lg-block"
             id="js--toggle-wrapper">
            <div class="row">
                <div class="col-lg-4">
                    <p class="single__description-headline h4">
                        {{ $translate("ODNaPo::NaPo.singleDescription") }}
                    </p>
                    <div class="single__description-text"
                         v-html="currentVariation.texts.description">
                    </div>
                </div>
                <div class="col-lg-4">
                    <p class="single__description-headline h4">
                        {{ $translate("ODNaPo::NaPo.singleShippingCosts") }}
                    </p>
                    <div class="single__description-text"
                         v-html="$translate('ODNaPo::NaPo.singleShippingContent')">
                    </div>
                </div>
                <div class="col-lg-4">
                    <p class="single__description-headline h4">
                        {{ $translate("ODNaPo::NaPo.singleShippingReturn") }}
                    </p>
                    <div class="single__description-text"
                         v-html="$translate('ODNaPo::NaPo.singleShippingReturnContent')">
                    </div>
                </div>
            </div>
        </div>

        <button id="js--toggle-text" class="single__description-btn">
            <span class="single__description-btn-text">
                {{ $translate("ODNaPo::NaPo.seoShowMore") }}
            </span>
            <span class="single__description-btn-text single__description-btn-text--open">
                {{ $translate("ODNaPo::NaPo.seoShowLess") }}
            </span>
        </button>

        <slot name="item-list-container"></slot>

        <div id="single-size-modal-wrapper">
            <div class="modal fade"
                 id="id--single-size-modal"
                 tabindex="-1"
                 role="dialog">
                <div class="modal-dialog">
                    <div class="modal__content">
                        <div class="modal__header">
                            <button type="button"
                                    class="modal__close"
                                    data-dismiss="modal"
                                    aria-hidden="true">
                                <svg width="20" height="20">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                         xlink:href="#svg-close"></use>
                                </svg>
                            </button>
                            <div class="modal__title">
                                {{ $translate("ODNaPo::NaPo.sizeTable") }}
                            </div>
                        </div>
                        <slot name="category-template-size-table"></slot>
                    </div>
                </div>
            </div>
        </div>

        <!--<not-available-reminder template="#vue-not-available-reminder"-->
                                <!--:attribute-size-id="{{ NaPoConfig.itemLists.attributeSizeId | json_encode }}"-->
                                <!--:attribute-color-id="{{ NaPoConfig.itemLists.attributeColorId | json_encode }}">-->
        <!--</not-available-reminder>-->
		<div class="container-max last-seen-container">

			<last-seen-item-list>
				<template #heading>
					<h2>Zuletzt angesehen</h2>
				</template>
			</last-seen-item-list>
		</div>


    </div>
</template>

<script>
    import { get } from "ceres/app/helper/get";
    import { isNullOrUndefined } from "ceres/app/helper/utils";
    import { replaceAll }from "ceres/app/helper/strings";
    import {mapGetters, mapState, mapActions} from "vuex";

    export default {

        props: {
            pleaseSelectOptionVariationId: {
                type: Number,
                default: 0
            },
            initPleaseSelectOption: {
                type: Boolean,
                default: false
            },
            showNetPrices: {
                type: Boolean,
                default: false
            },
            isWishListEnabled: {
                type: Boolean,
                default: false
            },
            itemId: {
                type: Number,
                required: true
            },
            afterKey: Object
        },

        data() {
            return {
                napoConfig   : App.napoConfig,
                ceresConfig  : App.config,
                manufacturer : {},
                links        : App.manufacturerLinks
            }
        },

        provide() {
            return {
                itemId: this.$props.itemId
            }
        },

        jsonDataFields: [
            "itemData",
            "attributesData",
            "variations"
        ],

        computed:
            {
                itemConfig() {
                    return App.config.item.itemData;
                },

                isDescriptionTabActive() {
                    return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                        && !!this.currentVariation.texts.description.length;
                },

                isRecommendedPriceActive() {
                    return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
                },

                isShortDescriptionActive() {
                    return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
                },

                hasShippingCostsCategoryId() {
                    return App.config.global.shippingCostsCategoryId > 0;
                },

                isTechnicalDataTabActive() {
                    return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                        && !!this.currentVariation.texts.technicalData.length;
                },

                variationGroupedProperties() {
                    return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
                },

                variationMissingProperties() {
                    return this.$store.getters[`${this.itemId}/variationMissingProperties`];
                },

                currentVariation() {
                    return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
                },

                uvp(){
                  for(let key1 in this.currentVariation.variationProperties){
                    for (let key2 in this.currentVariation.variationProperties[key1].properties){
                      if(this.currentVariation.variationProperties[key1].properties[key2].id === 78){
                        return this.currentVariation.variationProperties[key1].properties[key2].values.value
                      }
                    }
                  }

                  return null
                },

                isVariationSelected() {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
                },

                attributes() {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
                },

                units() {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
                },

                variationTotalPrice() {
                    return this.$store.getters[`${this.itemId}/variationTotalPrice`];
                },

                manufacturerLink() {

                    if(typeof this.manufacturer.id === 'undefined') {
                        this.manufacturer = this.currentVariation.item.manufacturer;
                    }

                    let name = this.manufacturer.name;

                    name = replaceAll(name,' ', '');
                    name = replaceAll(name, 'ß', 'ss');
                    name = replaceAll(name, "'", '');
                    name = replaceAll(name, "´", '');
                    name = replaceAll(name, "&", '');
                    name = replaceAll(name, ".", '');

                    if(typeof name !== 'undefined') {
                        name = name.toLowerCase();
                    }

                    if(this.links && this.links[name]) {
                        return this.links[name];
                    }else{
                        return false;
                    }

                },

                ...mapGetters([
                    "isLoggedIn"
                ]),

                ...mapState({
                    userData: state => state.user.userData
                }),

                b2bClass()
                {
                    if (this.isLoggedIn){
                        return this.userData.classId;
                    }
                }
            },

        created() {
            this.$store.dispatch("initVariation", this.itemData);
            this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
            this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId: this.itemId,
                attributes: this.attributesData,
                variations: this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey: this.afterKey
            });
        },

        mounted() {
            $('document').ready(function () {
                $('.single__loader').hide();
                $('.single__inner').show();
            });
        },

        methods:
            {
                createLoginModal()
                {
                    this.loadComponent("login-modal");

                },

                getDataField(field) {
                    return get(this.currentVariation, field);
                },

                getFilteredDataField(field, filter) {
                    if (!isNullOrUndefined(this.$options.filters[filter])) {
                        return this.$options.filters[filter](this.getDataField(field));
                    }

                    return this.getDataField(field);
                },

                ...mapActions([
                    "loadComponent"
                ])
            }
    }
</script>
